<template>
  <div>
    <template v-if="type === 'document'">
      <v-form @submit.prevent="submitDocument()">
        <div class="container">
          <div class="form-group">
            <label for="name">Document Name:</label>
            <input
              type="text"
              v-model="name"
              class="form-control"
              aria-describedby="nameHelp"
              placeholder="Name your document"
            />

            <small class="form-text text-muted">Example: Inspections</small>
          </div>

          <div class="form-group">
            <label for="description">Document Description:</label>
            <textarea
              v-model="description"
              class="form-control"
              placeholder="Add a description for your form here"
              rows="3"
            >
            </textarea>
          </div>

          <div class="form-group">
            <small class="form-text text-muted">
              Select a PDF Form from your computer to be used as a template to
              be filled
            </small>
          </div>

          <div class="form-group">
            <label for="form-file">Form File:</label>
            <input
              type="file"
              @change="uploadFiles"
              name="image"
              class="form-control"
              aria-describedby="fileHelp"
              placeholder="Select a file from your computer"
            />

            <small class="form-text text-muted">
              Select a PDF Form from your computer to be used as a template to
              be filled
            </small>
          </div>

          <div class="form-group mt-8 text-right">
            <v-btn
              style="color: white;"
              depressed
              color="#0D47A1"
              :disabled="name === '' || description === ''"
              rounded
              type="submit"
              small
            >
              Save Form
            </v-btn>

            <button
              type="button"
              @click="closeModal"
              class="ml-2 items-center px-3 py-1.5 text-xs font-medium rounded-full shadow-sm text-white bg-gray-600 hover:bg-gray-700 focus:outline-none"
            >
              Cancel
            </button>
          </div>
        </div>
      </v-form>
    </template>

    <template v-else-if="type === 'group'">
      <v-form @submit.prevent="createFormGroup()">
        <div class="container shadow">
          <div class="form-group">
            <label for="name">Group Name:</label>
            <input
              type="text"
              v-model="groupName"
              class="form-control"
              aria-describedby="nameHelp"
              placeholder="Group name"
            />

            <small id="nameHelp" class="form-text text-muted"
              >Example: Management - Buyer - Seller</small
            >
          </div>

          <div class="form-group mt-8 text-right">
            <v-btn
              style="color: white;"
              depressed
              color="#0D47A1"
              :disabled="groupName === ''"
              rounded
              type="submit"
              small
            >
              Create Group
            </v-btn>

            <button
              type="button"
              @click="closeModal"
              class="ml-2 items-center px-3 py-1.5 text-xs font-medium rounded-full shadow-sm text-white bg-gray-600 hover:bg-gray-700 focus:outline-none"
            >
              Cancel
            </button>
          </div>
        </div>
      </v-form>
    </template>

    <template v-else-if="type === 'menu'">
      <span
        v-for="item in items"
        :key="item.id"
        class="sm:ml-2 inline-flex items-center py-0.5 pl-2 pr-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800 sm:mb-4"
      >
        <span class="truncate">{{ item.name }} </span>
        <button
          @click="itemDelete(item)"
          type="button"
          class="flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-indigo-400 hover:bg-indigo-200 hover:text-indigo-500 focus:outline-none"
        >
          <svg
            class="h-2 w-2"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 8 8"
          >
            <path
              stroke-linecap="round"
              stroke-width="1.5"
              d="M1 1l6 6m0-6L1 7"
            />
          </svg>
        </button>
      </span>

      <v-form @submit.prevent="createNavMenu()">
        <div class="container shadow">
          <div class="form-group">
            <label for="name">Menu Item Name:</label>
            <input
              type="text"
              v-model="navMenu"
              class="form-control"
              aria-describedby="nameHelp"
              placeholder="Disclosures - Sample"
            />

            <small id="nameHelp" class="form-text text-muted"
              >Example: Sample Documents - Templates
            </small>
          </div>

          <div class="form-group mt-8 text-right">
            <v-btn
              style="color: white;"
              depressed
              color="#0D47A1"
              :disabled="navMenu.length < 3"
              rounded
              type="submit"
              small
            >
              Add Item
            </v-btn>

            <button
              type="button"
              @click="closeModal"
              class="ml-2 items-center px-3 py-1.5 text-xs font-medium rounded-full shadow-sm text-white bg-gray-600 hover:bg-gray-700 focus:outline-none"
            >
              Cancel
            </button>
          </div>
        </div>
      </v-form>
    </template>
  </div>
</template>

<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>

<script>
import Swal from "sweetalert2";
export default {
  props: ["type", "items"],
  data() {
    return {
      name: "",
      description: "",
      document: [],

      groupName: "",
      navMenu: ""
    };
  },

  methods: {
    closeModal() {
      this.$emit("update");
    },

    uploadFiles(e) {
      this.document = e.target.files || e.dataTransfer.files;
    },

    submitDocument() {
      var config = {
        headers: { "Content-Type": "multipart/form-data" }
      };

      let pdfDoc = new FormData();

      $.each(this.document, function(key, image) {
        pdfDoc.append(`images[${key}]`, image);
      });

      pdfDoc.append("name", this.name);
      pdfDoc.append("description", this.description);

      window.axios.post("/api/documents", pdfDoc, config).then(() => {
        this.$emit("close");
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Document Added successfully",
          showConfirmButton: false,
          timer: 1500
        });
      });
    },

    createFormGroup() {
      window.axios
        .post("/api/formGroup", {
          groupName: this.groupName
        })
        .then(() => {
          this.$emit("close");
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Group successfully created",
            showConfirmButton: false,
            timer: 1500
          });
        });
    },

    createNavMenu() {
      window.axios
        .post("/api/navMenu", {
          name: this.navMenu
        })
        .then(() => {
          this.$emit("close");
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Navigation Item successfully created",
            showConfirmButton: false,
            timer: 1500
          });
        });
    },

    itemDelete(item) {
      window.axios.post("/api/removeItem/" + item.id).then(() => {
        this.$emit("close");
      });
    }
  }
};
</script>
